import { openDrawerPane } from 'owa-drawer';
import { flexPaneOpened } from 'owa-suite-header-apis';
import { setIsFlexPaneShown } from 'owa-suite-header-store';
import { triggerResizeEvent } from 'owa-resize-event';

export default function openHeaderPane(paneId: string, targetWindow?: Window): void {
    openDrawerPane(paneId, targetWindow);
    setIsFlexPaneShown(paneId, true);
    flexPaneOpened(paneId);
    triggerResizeEvent();
}
